import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiShoppingBag, FiMenu, FiX } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import CurrencyToggle from './CurrencyToggle';
import '../styles/Navbar.css';

const LOGO_URL = 'https://res.cloudinary.com/dnx6y0737/image/upload/v1775900226/Untitled_design_1_cziq8t.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { getItemCount } = useCart();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Početna' },
    { path: '/meni', label: 'Meni' },
    { path: '/rezervacije', label: 'Rezervacije' },
    { path: '/galerija', label: 'Galerija' },
    { path: '/kontakt', label: 'Kontakt' },
    { path: '/o-nama', label: 'O nama' }
  ];

  return (
    <nav 
      className={`navbar ${scrolled ? 'scrolled' : ''}`}
      style={
        mobileOpen && !scrolled
          ? {
              background: 'rgba(8, 6, 3, 0.95)',
              backdropFilter: 'blur(40px) saturate(200%)',
              WebkitBackdropFilter: 'blur(40px) saturate(200%)',
            }
          : {}
      }
    >
      <div className="navbar-container">
        <Link to="/" className="logo">
          <img src={LOGO_URL} alt="Sfension" className="logo-image" />
        </Link>

        <div className="nav-links">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="nav-actions">
  <div style={{ 
    opacity: location.pathname === '/meni' || location.pathname === '/korpa' ? 1 : 0,
    pointerEvents: location.pathname === '/meni' || location.pathname === '/korpa' ? 'auto' : 'none',
    transition: 'opacity 0.3s ease'
  }}>
    <CurrencyToggle />
  </div>
  
  <Link to="/korpa" className={`cart-btn ${location.pathname === '/korpa' ? 'active' : ''}`}>
  <FiShoppingBag />
  {getItemCount() > 0 && (
    <motion.span 
      className="cart-count"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      key={getItemCount()}
    >
      {getItemCount()}
    </motion.span>
  )}
</Link>

          <button 
            className="mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div 
            className="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-link ${location.pathname === link.path ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;